module.exports = __webpack_public_path__ + "img/momo_home_bg_7.c32ec923.png";